export default __webpack_public_path__ + "static/media/banner.90bc9a87.jpg";